const navigations = document.querySelectorAll('.j-navigation');

const initNavigationHover = () => {
    navigations.forEach((item) => {
        item.addEventListener('mouseover', (evt) => {
            const currentNav = evt.currentTarget;
            const isLink = evt.target.classList.contains('main-nav__link');

            if (!currentNav.classList.contains('main-nav__list_status_hover') && isLink) {
                currentNav.classList.add('main-nav__list_status_hover');
            }
        });

        item.addEventListener('mouseout', (evt) => {
            const currentNav = evt.currentTarget;

            if (currentNav.classList.contains('main-nav__list_status_hover')) {
                currentNav.classList.remove('main-nav__list_status_hover');
            }
        });
    });
};

export {initNavigationHover};
